import { getCurrentWindowSize, subscribeToResize } from '../eventListenerManager/resizeManager';
import { checkCookie, cookieValue } from '../genericUtils/cookieUtils';
import { useEffect, useState } from 'react';

export const useCookieValue = (cookieName: string) => {
  if (!cookieName || cookieName.length === 0) {
    return '';
  }
  const value = checkCookie(cookieName) ? cookieValue(cookieName) : '';
  const setCookieValue = (value: string, age: number) => {
    const cookieSettings = `path=/; domain=${window.location.hostname};Max-Age=${
      age !== undefined ? age : 3600
    }`;
    document.cookie = `${cookieName}=${value};${cookieSettings}`;
  };

  return [value, setCookieValue];
};

export const useEventListener = (
  target: EventTarget,
  type: string,
  listener: EventListenerOrEventListenerObject,
  ...rest: any[]
): void => {
  useEffect(() => {
    target.addEventListener(type, listener, ...rest);

    // return a callback, which is called on unmount
    return () => {
      target.removeEventListener(type, listener, ...rest);
    };
  }, [listener, rest, target, type]);
};

// custom hook to get the window size
export const useWindowSize = (): { width: number; height: number } => {
  const [windowSize, setWindowSize] = useState(getCurrentWindowSize());

  useEffect(() => {
    const cleanup = subscribeToResize((size) => setWindowSize(size));
    return cleanup;
  }, []);

  return windowSize;
};
